module.exports = __webpack_public_path__ + "img/新手任务.e666c01e.png";